import React from "react";
import { useGetParameterName } from "app/view/hooks/useGetParameterName";
import { useGetMaterialName } from "app/view/hooks/useGetMaterialById";
import { useGetMachineName } from "app/view/hooks/useGetMachineName";
import SecondReport from "./SecondReport";
import { EditText } from "react-edit-text";
import { useRecoilState, useRecoilValue } from "recoil";
import { CCPolyworkingWeeksPerYear, WorkingHours } from "atoms/General";

const FirstReport = ({ staticData, ScenarioState,
  cppData,
  setCppData,
  totalJobs,
  setTotalJobs,
  setSingleJobTime,
  singleJobTime,
  machineImage,
  setMachineimage,
  psImage,
  setPsImage,
  setcppSum,
  cppSum,
  setHotSpotArray,
  hotspotArray,
  isWorkingPerJobEditable
 }) => {
  const materialName = useGetMaterialName(+staticData?.material_id?.value);
  const parameterName = useGetParameterName(+staticData?.parameter_id?.value);
  const machineName = useGetMachineName(+staticData?.machine_id?.value);
    const [workingWeeksPerYear, setWorkingWeeksPerYear] = useRecoilState(
    CCPolyworkingWeeksPerYear
  );
  const workingHours = useRecoilValue(WorkingHours)
  const jobYear = workingWeeksPerYear * totalJobs;

  const jobTime =
    +staticData?.setup_time?.value +
    +staticData?.build_time?.value +
    +staticData?.unpacking_time_per_job?.value +
    +staticData?.cool_down_time_in_system?.value;

  const partWeight =
    staticData?.part_volume?.value * staticData?.material_density?.value;
  // Getting Currency Symbol...
  const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
  const currency = sessionStorage.getItem("currency");
  const obj = currencies.find((x) => x.currency_symbol === currency);

  return (
    <div className="mt-36 d-flex flex-column gap-20">
      {/* first row */}
      <div className="report-row">
        {/* Part Information */}
        <div className="report-container  report-col">
          <div className="mb-36">
            <p className="font-24 font-semi-bold">Part Information</p>
            <p className="powder-heading">
              {staticData?.part_name && staticData?.part_name?.value}
            </p>
          </div>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Material</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {materialName}
              </p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Material price</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.material_price?.value !== undefined
                  ? `${staticData?.material_price?.value} ${obj.currency_symbol}/kg`
                  : "No Available"}
              </p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Part volume</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.part_volume?.value !== undefined ? (
                  <>
                    {`${staticData?.part_volume?.value} cm`}
                    <sup>3</sup>
                  </>
                ) : (
                  "Not Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>

          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Part weight</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {partWeight ? `${partWeight.toFixed(2)} g` : "Not Available"}
              </p>
            </span>
          </div>
        </div>
        {/* Job Details */}

        <div className="report-container  report-col">
          <div className="mb-36">
            <p className="font-24 font-semi-bold">Job details</p>
          </div>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Nesting density</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.fill_rate?.value ? (
                  <>{`${staticData?.fill_rate?.value} %`}</>
                ) : (
                  "Not Available"
                )}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>

          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Parts per job</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.no_of_parts?.value ? (
                  <>{`${staticData?.no_of_parts?.value}`}</>
                ) : (
                  "Not Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Total job volume</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.build_volume?.value ? (
                  <>
                    {`${staticData?.build_volume?.value} cm`}
                    <sup>3</sup>
                  </>
                ) : (
                  "Not Available"
                )}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Job time</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {jobTime ? <>{`${jobTime} h/min`}</> : "Not Available"}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Parameter</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {parameterName}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Additional material losses</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.additional_material_losses?.value ? (
                  <>{`${staticData?.additional_material_losses?.value} %`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
        </div>
      </div>

      {/* second row       */}
      <div className="report-row">
        {/* System Information */}
        <div className="report-container  report-col">
          <div className="d-flex justify-content-lg-between mb-36 align-items-center">
            <span className="font-24 font-semi-bold">System Information</span>
            <span className="powder-heading">{machineName}</span>
          </div>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Initial investment</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.initial_investment?.value !== undefined ? (
                  <>{`${staticData?.initial_investment?.value} ${obj.currency_symbol}`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>

          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Recurring Expense per year</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.recurring_expense?.value ? (
                  <>{`${staticData?.recurring_expense?.value} ${obj.currency_symbol}/year`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Depreciation period</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.depreciation_period?.value ? (
                  <>{`${staticData?.depreciation_period?.value} year`}</>
                ) : (
                  "No Available"
                )}{" "}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Interest rate</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.interest_rate?.value ? (
                  <>{`${staticData?.interest_rate?.value} %`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Utilization per year</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.utilization?.value ? (
                  <>{`${staticData?.utilization?.value} hours/year`}</>
                ) : (
                  "No Available"
                )}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">CAPEX per year</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.utilization?.value ? (
                  <>{`${staticData?.capex_per_year?.value} ${obj.currency_symbol}/year`}</>
                ) : (
                  "No Available"
                )}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">System cost per hour</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticData?.system_cost_per_hour?.value ? (
                  <>{`${staticData?.system_cost_per_hour?.value} ${obj.currency_symbol}/year`}</>
                ) : (
                  "No Available"
                )}{" "}
              </p>{" "}
            </span>
          </div>
        </div>
        {/* Production Scenarios */}
        <div className="report-container  report-col">
          <div className="mb-36">
            <p className="font-24 font-semi-bold">Production Scenarios</p>
          </div>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Builds per week</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {totalJobs == null ? "Not Available" : totalJobs}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Working weeks per year</p>
            </span>
            {isWorkingPerJobEditable === null ? (
              <span>
                <p className="font-16  color-blue font-semi-bold">
                  <EditText
                    name="working-weeks-per-year"
                    style={{ fontSize: "16px", border: "1px solid #ccc" }}
                    value={workingWeeksPerYear}
                    onChange={(event) =>
                      setWorkingWeeksPerYear(event.target.value)
                    }
                  />
                </p>
              </span>
            ) : (
              <span>
                <p className="font-16  color-blue font-semi-bold">
                  {workingWeeksPerYear == null
                    ? "Not Available"
                    : workingWeeksPerYear}
                </p>{" "}
              </span>
            )}
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Jobs per year</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {jobYear == null ? "Not Available" : Math.round(jobYear)}
              </p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Throughput per year</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {Math.trunc(+(jobYear * +staticData?.no_of_parts?.value))}
              </p>
            </span>
          </div>

          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Turnaround time</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">{`${singleJobTime} h`}</p>{" "}
            </span>
          </div>

          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Operators needed per machine</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">{+staticData?.number_of_operators?.value}</p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Number of shifts</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">{
                workingHours === "true" ? 1 : 3
              }</p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Operator’s time needed per job</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">{+staticData?.unpacking_time_per_job?.value + +staticData?.setup_time?.value} h</p>{" "}
            </span>
          </div>
        </div>
      </div>

      {/* <button
        onClick={() => ScenarioState()}
        className="selection-button step-button"
      >
        Next
      </button> */}

      <SecondReport
        isHotSpotAvailable={true}
        staticData={staticData}
        isWorkingPerJobEditable={true}
        cppData={cppData}
        setCppData={setCppData}
        totalJobs={totalJobs}
        setTotalJobs={setTotalJobs}
        setSingleJobTime={setSingleJobTime}
        singleJobTime={singleJobTime}
        machineImage={machineImage}
        setMachineimage={setMachineimage}
        psImage={psImage}
        setPsImage={setPsImage}
        setcppSum={setcppSum}
        cppSum={cppSum}
        setHotSpotArray={setHotSpotArray}
        hotspotArray={hotspotArray}
        setWorkingWeeksPerYear={setWorkingWeeksPerYear}
        workingWeeksPerYear={workingWeeksPerYear}
        // PreviousScenarioState={() => setStep(STEPS.ONE)}
        // ScenarioState={() => setStep(STEPS.THREE)}
      />
    </div>
  );
};

export default FirstReport;
